module.exports = __webpack_public_path__ + "img/存款.0f16eb30.png";